/* Extracted 2026-10-10 from sections/tlc-nav.liquid (SEO audit C1). Section id + search url arrive via window.__tlcNavSid / window.__tlcSearchUrl, set inline just before this script loads. */
/* TLC bag-count live sync — the nav badge (.ni-cc) + mobile "Bag (N)" are
   server-rendered ONLY, and the span isn't even printed when the cart is empty.
   So any AJAX add (PDP product-form, cart drawer, etc.) left the bag showing the
   stale/zero count — looking like "nothing was added". This repaints the count
   after any AJAX cart mutation and on bfcache back/forward restores. */
(function(){
  if(window.__tlcBagSync) return; window.__tlcBagSync = true;
  var _f = window.fetch;
  function paint(count){
    document.querySelectorAll('a.ni-ic[href*="/cart"]').forEach(function(a){
      var cc = a.querySelector('.ni-cc');
      if(count > 0){
        if(!cc){ cc = document.createElement('span'); cc.className = 'ni-cc'; a.appendChild(cc); }
        cc.textContent = count;
      } else if(cc){ cc.remove(); }
    });
    document.querySelectorAll('.df a[href*="/cart"]').forEach(function(a){
      var svg = a.querySelector('svg'); a.textContent = '';
      if(svg) a.appendChild(svg);
      a.appendChild(document.createTextNode(count > 0 ? ('Bag (' + count + ')') : 'Bag'));
    });
  }
  function pull(){
    _f('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(c){ if(c) paint(c.item_count); })
      .catch(function(){});
  }
  // refresh after any AJAX cart mutation, regardless of which script fired it
  window.fetch = function(input){
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = _f.apply(this, arguments);
    if(/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)){
      p.then(function(r){ if(r && r.ok) setTimeout(pull, 50); }).catch(function(){});
    }
    return p;
  };
  // correct a stale badge on back/forward (bfcache restores the old server-rendered count)
  window.addEventListener('pageshow', pull);
  ['cart:change','cart:refresh','cart:updated','cart:build'].forEach(function(ev){ document.addEventListener(ev, pull); });
})();
(function(){
  var burger  = document.getElementById('tlcnBurger');
  var overlay = document.getElementById('tlcnOverlay');
  var drawer  = document.getElementById('tlcnDrawer');
  var closeBtn= document.getElementById('tlcnClose');

  function open(){
    drawer.classList.add('open');
    overlay.classList.add('open');
    burger.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
  }
  function close(){
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    burger.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  }

  burger.addEventListener('click', open);
  overlay.addEventListener('click', close);
  closeBtn.addEventListener('click', close);

  // Close on Escape
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && drawer.classList.contains('open')) close();
  });

  // Accordion — only sections with data-s have a chevron toggle (legacy + footer)
  drawer.querySelectorAll('.ds[data-s], .tlcn-foot-nav .ds').forEach(function(sec){
    var trigger = sec.querySelector('.dt');
    if(!trigger) return;
    // Skip dt blocks that are just a direct link with no chevron (FAQs/Blogs/Contact)
    if(!sec.querySelector('.dch') && !sec.hasAttribute('data-s')) return;
    trigger.addEventListener('click', function(){
      var isOpen = sec.classList.contains('open');
      drawer.querySelectorAll('.tlcn-foot-nav .ds, .ds[data-s]').forEach(function(s){ s.classList.remove('open'); });
      if(!isOpen) sec.classList.add('open');
    });
  });

  // TLC 2026-05-31 — Hira-style top tab switcher.
  // Click swaps the .active class on tab + matching panel; hidden attr also
  // toggles so AT users don't see inactive panels in the a11y tree.
  var tabs   = drawer.querySelectorAll('.tlcn-tab[data-tab]');
  var panels = drawer.querySelectorAll('.tlcn-panel');
  tabs.forEach(function(tab){
    tab.addEventListener('click', function(){
      var target = tab.getAttribute('data-tab');
      tabs.forEach(function(t){
        var on = (t === tab);
        t.classList.toggle('active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function(p){
        var on = p.getAttribute('data-panel') === target;
        p.classList.toggle('active', on);
        if(on){ p.removeAttribute('hidden'); } else { p.setAttribute('hidden',''); }
      });
    });
  });

  // TLC 2026-07-24 — LV two-level drawer (gated by .tlv on #tlcnDrawer)
  if(drawer.classList.contains('tlv')){
    var lvBack = document.getElementById('tlvBack');
    var lvBackLabel = document.getElementById('tlvBackLabel');
    var lvPanels = drawer.querySelectorAll('.tlv-panel');
    var lvHome = function(){
      drawer.classList.remove('l2');
      lvPanels.forEach(function(p){ p.classList.remove('lvon'); });
    };
    drawer.querySelectorAll('.tlv-l1 > button[data-lv]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var target = btn.getAttribute('data-lv');
        lvPanels.forEach(function(p){
          var on = p.getAttribute('data-tlv') === target;
          p.classList.toggle('lvon', on);
          if(on) p.scrollTop = 0;
        });
        if(lvBackLabel) lvBackLabel.textContent = btn.textContent;
        drawer.classList.add('l2');
      });
    });
    if(lvBack) lvBack.addEventListener('click', lvHome);
    // Reset to level 1 whenever the drawer closes (wrap close, rebind listeners)
    var _lvClose = close;
    close = function(){ _lvClose(); lvHome(); };
    overlay.removeEventListener('click', _lvClose); overlay.addEventListener('click', close);
    closeBtn.removeEventListener('click', _lvClose); closeBtn.addEventListener('click', close);
  }

  // Set --header-height for the theme (used by other sections)
  var section = document.getElementById((window.__tlcNavSid || ""));
  if(section){
    document.documentElement.style.setProperty('--header-height', Math.round(section.clientHeight) + 'px');
  }

  // Compute total top offset: announcement bar + tlc-nav. Used to dock the mega
  // panel and its backdrop right below the visible header complex.
  function updateTopOffset(){
    var top = 0;
    var anno = document.querySelector('.shopify-section-group-announcement-bar-group, .shopify-section--announcement-bar, #shopify-section-sections--' + (section ? section.id.replace(/^shopify-section-sections--/,'').split('__')[0] : '') + '__announcement-bar');
    if(!anno){ anno = document.querySelector('[id*="announcement-bar"]'); }
    if(anno){ top += anno.getBoundingClientRect().height; }
    if(section){ top += section.getBoundingClientRect().height; }
    document.documentElement.style.setProperty('--tlcn-top-offset', Math.round(top) + 'px');
  }
  updateTopOffset();
  window.addEventListener('resize', updateTopOffset);
  window.addEventListener('scroll', updateTopOffset, {passive:true});

  // ============ Desktop mega menu — Rituals-style click-triggered left slide-out ============
  var megaOverlay = document.getElementById('tlcnMegaOverlay');
  var openMega = null;
  var openLi = null;

  function closeMega(){
    if(openMega){ openMega.classList.remove('open'); openMega = null; }
    if(openLi){ openLi.classList.remove('is-open'); openLi = null; }
    if(megaOverlay) megaOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  function openMegaFor(li, mega){
    if(openMega === mega){ closeMega(); return; }
    if(openMega){ openMega.classList.remove('open'); }
    if(openLi){ openLi.classList.remove('is-open'); }
    mega.classList.add('open');
    li.classList.add('is-open');
    if(megaOverlay) megaOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    openMega = mega; openLi = li;
  }

  if(section){
    section.querySelectorAll('.ni-i').forEach(function(li){
      var trigger = li.querySelector(':scope > a');
      var mega = li.querySelector(':scope > .mega');
      if(!trigger || !mega) return;
      trigger.addEventListener('click', function(e){
        // Only intercept on desktop (≥1025px). Below that, the mobile drawer is used.
        if(window.matchMedia('(max-width:1024px)').matches) return;
        e.preventDefault();
        openMegaFor(li, mega);
        // Reset to first tile-set & first link as active whenever a mega opens
        var firstSet = mega.querySelector('.tile-set.active') || mega.querySelector('.tile-set');
        if(firstSet){
          mega.querySelectorAll('.tile-set').forEach(function(s){ s.classList.remove('active'); });
          firstSet.classList.add('active');
        }
        var firstLink = mega.querySelector('.ll a.tg-active[data-tg]') || mega.querySelector('.ll a[data-tg]');
        if(firstLink){
          mega.querySelectorAll('.ll a[data-tg]').forEach(function(a){ a.classList.remove('tg-active'); });
          firstLink.classList.add('tg-active');
        }
      });
      mega.querySelectorAll('.mega-close').forEach(function(btn){
        btn.addEventListener('click', function(e){ e.stopPropagation(); closeMega(); });
      });
      // Hover a left-pane link -> swap which right-pane tile-set is visible
      // Only the hovered link gets the active underline (not its whole group).
      // Click is intentionally suppressed on desktop — left pane is a navigator
      // for the right pane; users click the tiles on the right to navigate.
      mega.querySelectorAll('.ll a[data-tg]').forEach(function(link){
        link.addEventListener('click', function(e){
          if(window.matchMedia('(max-width:1024px)').matches) return; // mobile: allow nav
          e.preventDefault();
          e.stopPropagation();
        });
        link.addEventListener('mouseenter', function(){
          var tg = link.getAttribute('data-tg');
          mega.querySelectorAll('.tile-set').forEach(function(set){
            set.classList.toggle('active', set.getAttribute('data-tg') === tg);
          });
          // Mark ONLY the hovered link as active — clean single underline
          mega.querySelectorAll('.ll a[data-tg]').forEach(function(a){
            a.classList.remove('tg-active');
          });
          link.classList.add('tg-active');
        });
      });
    });
    if(megaOverlay) megaOverlay.addEventListener('click', closeMega);
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && openMega) closeMega();
    });
    window.addEventListener('resize', function(){
      if(openMega && window.matchMedia('(max-width:1024px)').matches) closeMega();
    });
  }

  // Keep the custom TLC search trigger deterministic. The theme's generic
  // aria-controls handler can miss early clicks while the drawer custom element
  // is still upgrading, so this scoped handler waits for x-drawer before open.
  var sd = document.getElementById('search-drawer');
  var navRoot = document.getElementById((window.__tlcNavSid || "")) || document;

	  function normalizeNavLabels(){
	    if(!navRoot){ return; }

      navRoot.querySelectorAll('.ni-i > a[href*="/collections/body"], .nls > .ni-i > a[href*="/collections/body"], .tlcn-tab[data-tab="body"], .tlcn-tab[href*="/collections/body"], .ni-i > a[href*="/collections/body-care"]').forEach(function(anchor){
        if(anchor.textContent.trim() === 'Body'){
          anchor.textContent = 'Body Care';
        }
      });

	    navRoot.querySelectorAll('.ni-i > a[href*="/collections/bestsellers"], .nls > .ni-i > a[href*="/collections/bestsellers"], .tlcn-tab[href*="/collections/bestsellers"], .tlcn-foot-nav .dt > a[href*="/collections/bestsellers"], .tlcn-head-nav .dt > a[href*="/collections/bestsellers"], .ds > .dt > a[href*="/collections/bestsellers"]').forEach(function(anchor){
	      var txt = anchor.textContent.trim();
	      if(txt !== 'Bestsellers' && txt !== 'Best Sellers'){ return; }

      if (
        anchor.classList.contains('ni-ritual') ||
        anchor.classList.contains('tlcn-tab') ||
        anchor.closest('.nls') ||
        anchor.closest('.tlcn-tabs') ||
        anchor.closest('.ds') && anchor.closest('.ds').querySelector('.dt') === anchor.parentElement
      ) {
	        anchor.textContent = 'The Love Of';
	      }
	    });

	    var bodyTrigger = navRoot.querySelector('.nls > .ni-i > a[href*="/collections/body"]');
	    var bodyMega = bodyTrigger && bodyTrigger.parentElement ? bodyTrigger.parentElement.querySelector(':scope > .mega.m-sol') : null;
	    if(bodyMega){
	      var leftEyebrow = bodyMega.querySelector('.fg > .mega-eyebrow');
	      if(leftEyebrow){ leftEyebrow.innerHTML = 'Shop: Body <span class="ar">›</span>'; }

	      [
	        ['body-bath', '/collections/body-wash', 'Bath & Shower', false],
	        ['body-care', '/collections/body', 'Body Care', true],
	        ['body-hair', '/collections/hair-care', 'Hair', false],
	        ['body-hands', '/collections/hand-wash-the-love-co', 'Hands', false],
	        ['body-sun', '/collections/suncare-the-love-co', 'Sunscreen', false],
	        ['body-men', '/collections/men-fragrance', 'Men', false]
	      ].forEach(function(item){
	        var a = bodyMega.querySelector('.ll-main a[data-tg="' + item[0] + '"]');
	        if(!a){ return; }
	        a.setAttribute('href', item[1]);
	        a.textContent = item[2];
	        a.classList.toggle('tg-active', item[3]);
	      });

	      function updateSet(key, eyebrow, tiles, active){
	        var set = bodyMega.querySelector('.tile-set[data-tg="' + key + '"]');
	        if(!set){ return; }
	        set.classList.toggle('active', !!active);
	        var title = set.querySelector(':scope > .mega-eyebrow');
	        if(title){ title.innerHTML = eyebrow + ' <span class="ar">›</span>'; }
	        set.querySelectorAll('.nt').forEach(function(tile, idx){
	          if(!tiles[idx]){ return; }
	          tile.setAttribute('href', tiles[idx][0]);
	          var label = tile.querySelector('.tl');
	          if(label){ label.textContent = tiles[idx][1]; }
	        });
	      }

	      updateSet('body-bath', 'Shop: Bath & Shower', [
	        ['/collections/shower-gel', 'Shower Gels'],
	        ['/collections/body-wash', 'Active+'],
	        ['/collections/oud', 'Oud Shower Gel'],
	        ['/collections/discovery-sets', 'Travel EDT'],
	        ['/collections/bubble-bath', 'Bubble Bath'],
	        ['/collections/bath-salt', 'Bath Salts'],
	        ['/collections/travel-shower-gel', 'Minis']
	      ], false);
	      updateSet('body-care', 'Shop: Body Care', [
	        ['/collections/body-lotion', 'Body Lotions'],
	        ['/collections/body-butter', 'Body Butters'],
	        ['/collections/body-scrub', 'Body Scrubs'],
	        ['/collections/body-oil-the-love-co', 'Body Oils'],
	        ['/collections/in-shower-the-love-co', 'In-Shower Moisturiser'],
	        ['/collections/travel-shower-gel', 'Minis'],
	        ['/collections/body-yogurt', 'Body Yogurts'],
	        ['/collections/body-wash', 'Active+']
	      ], true);
	      updateSet('body-hair', 'Shop: Hair', [
	        ['/collections/shampoo', 'Shampoos & Conditioners'],
	        ['/collections/hair-mist', 'Hair Mists']
	      ], false);
	      updateSet('body-sun', 'Shop: Sunscreen', [['/collections/suncare-the-love-co', 'Sunscreen']], false);
	      updateSet('body-men', 'Shop: Men', [['/collections/men-fragrance', 'Men']], false);
	    }
	  }
  function focusSearchDrawerInput(){
    var i = document.getElementById('search-drawer-input');
    if (i) { try { i.focus(); } catch(e){} }
  }
  function showSearchDrawer(activator){
    sd = document.getElementById('search-drawer');
    var searchUrl = (window.__tlcSearchUrl || "/search");
    // No drawer in DOM yet — never leave the click dead, go to the search page.
    if (!sd) { window.location.href = searchUrl; return; }

    if (typeof sd.show === 'function') {
      if (!sd.open) sd.show({ activator: activator });
      window.setTimeout(focusSearchDrawerInput, 80);
      return;
    }

    // x-drawer still upgrading (cold load): wait briefly, but fall back to the
    // full search page if it isn't ready — so the first click never needs a refresh.
    var settled = false;
    var fallbackTimer = window.setTimeout(function(){
      if (!settled) { settled = true; window.location.href = searchUrl; }
    }, 600);
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('x-drawer').then(function(){
        if (settled) return;
        settled = true; window.clearTimeout(fallbackTimer);
        sd = document.getElementById('search-drawer');
        if (sd && typeof sd.show === 'function') {
          if (!sd.open) sd.show({ activator: activator });
          window.setTimeout(focusSearchDrawerInput, 80);
        } else { window.location.href = searchUrl; }
      }).catch(function(){ if (!settled) { settled = true; window.clearTimeout(fallbackTimer); window.location.href = searchUrl; } });
    } else {
      // Very old browser, no customElements: just use the search page.
      if (!settled) { settled = true; window.clearTimeout(fallbackTimer); window.location.href = searchUrl; }
    }
  }
  if (sd) {
    sd.addEventListener('dialog:after-show', function(){
      focusSearchDrawerInput();
    });
  }

  if (navRoot) {
    // TLC 2026-07-10: desktop search is a plain inline <form> now (no drawer hijack — it froze).
    // Only the MOBILE search icon still opens the drawer, with the page fallback if it's not ready.
    // Also shield the inline form from the theme's generic capture handlers so typing always works.
    var inlineSearch = navRoot.querySelector('form.ni-search-form');
    if (inlineSearch) {
      ['click','focusin','keydown'].forEach(function(evt){
        inlineSearch.addEventListener(evt, function(event){ event.stopPropagation(); });
      });
    }
    navRoot.querySelectorAll('.nrm .ni-ic[aria-controls="search-drawer"]').forEach(function(el){
      el.addEventListener('click', function(event){
        event.preventDefault();
        event.stopImmediatePropagation();
        showSearchDrawer(el);
      }, true);
    });

    normalizeNavLabels();
  }

  /* TLC 2026-07-25: slim-on-scroll moved from a rAF-throttled window scroll
     listener to an IntersectionObserver sentinel. The old version worked (it
     was verified toggling in real Chrome); this one does the same job with no
     scroll listener and no per-frame work, and it keeps reporting in tabs that
     aren't being painted, where rAF is suspended. A 140px-tall sentinel is
     pinned at the top of the document: sentinel out of view = slim mast,
     sentinel in view = full mast. Desktop only (≥1025px); mobile keeps the
     50px bar. */
  var navSection = document.getElementById((window.__tlcNavSid || ""));
  if (navSection && 'IntersectionObserver' in window) {
    var slimSentinel = document.createElement('div');
    slimSentinel.className = 'tlcn-slim-sentinel';
    slimSentinel.setAttribute('aria-hidden', 'true');
    slimSentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:140px;pointer-events:none;';
    document.body.insertBefore(slimSentinel, document.body.firstChild);

    var slimPast = false;
    function applySlim(){
      // Mobile never slims — .ni is already the compact 50px bar there.
      // .tlcn-slim is the same toggle mirrored onto <html> (2026-09-23) so tlc-bbw-search-row.liquid,
      // a sibling section, can size its own sticky `top` off the nav's real height with no JS of its own.
      if (window.innerWidth < 1025) { navSection.classList.remove('is-slim'); document.documentElement.classList.remove('tlcn-slim'); return; }
      navSection.classList.toggle('is-slim', slimPast);
      document.documentElement.classList.toggle('tlcn-slim', slimPast);
    }
    new IntersectionObserver(function(entries){
      slimPast = !entries[entries.length - 1].isIntersecting;
      applySlim();
      // Hysteresis: once slim, the sentinel shrinks to 100px, so the mast only
      // grows back after scrolling above 100 — not the instant you cross 140
      // again. Restores the 40px deadband the old scroll listener had, which
      // is what stops the bar flickering when you hover around the threshold.
      // Converges in one step: shrinking the sentinel never makes it intersect
      // again while scrolled past it, and vice versa.
      slimSentinel.style.height = slimPast ? '100px' : '140px';
    }).observe(slimSentinel);
    window.addEventListener('resize', applySlim, { passive: true });

    /* 2026-09-23: BBW-style full hide, a second stage past the slim one — same
       sentinel + hysteresis pattern, just a deeper 320px trip point so the mast
       visibly slims first and only then folds away. Desktop only, same as slim. */
    var hideSentinel = document.createElement('div');
    hideSentinel.className = 'tlcn-hide-sentinel';
    hideSentinel.setAttribute('aria-hidden', 'true');
    hideSentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:320px;pointer-events:none;';
    document.body.insertBefore(hideSentinel, document.body.firstChild);

    var hidePast = false;
    function applyHide(){
      // .tlcn-hide mirrored onto <html> for the same reason as .tlcn-slim above.
      if (window.innerWidth < 1025) { navSection.classList.remove('is-hidden'); document.documentElement.classList.remove('tlcn-hide'); return; }
      navSection.classList.toggle('is-hidden', hidePast);
      document.documentElement.classList.toggle('tlcn-hide', hidePast);
    }
    new IntersectionObserver(function(entries){
      hidePast = !entries[entries.length - 1].isIntersecting;
      applyHide();
      hideSentinel.style.height = hidePast ? '260px' : '320px';
    }).observe(hideSentinel);
    window.addEventListener('resize', applyHide, { passive: true });
  }
})();
